import { getProductImageUrls } from "../../auth/elakay-utils";

// FollowMe = 1 shop, 1 gallery. The backend (/productsF followMeMatrix, see
// server_elakay/elakay_helpers/followMeGallery.js) already merges the images
// of the shop's Simple, Dropshipping Out and Dropshipping In products into
// `images[]`, each entry still tied to its product. A payload without
// `images[]` (older backend) falls back to the products' own image fields via
// the shared getProductImageUrls() resolver.
export const FOLLOW_ME_GALLERY_LIMIT = 20;
const FALLBACK_IMAGES_PER_PRODUCT = 6;

// Same Product View route as ShowImage.js / Card.js. A Dropshipping In image
// points at the Seller's own linked product (its _id/publicId), never at the
// Provider's product.
export const buildFollowMeProductUrl = (productId) =>
  productId ? `/product/preview/${productId}` : null;

const imagesFromProducts = (products) =>
  (Array.isArray(products) ? products : []).flatMap((product) =>
    getProductImageUrls(product, FALLBACK_IMAGES_PER_PRODUCT).map((url) => ({
      url,
      productId: product?._id,
      productPublicId: product?.publicId,
      productName: product?.name,
      productType: product?.productType,
    }))
  );

// ?bgc=<color> is a background variant of the same photo, not another photo.
const dedupeKey = (url) => url.split("?bgc=")[0];

export function buildFollowMeShopGallery(followMeMatrix, limit = FOLLOW_ME_GALLERY_LIMIT) {
  const source = Array.isArray(followMeMatrix?.images)
    ? followMeMatrix.images
    : imagesFromProducts(followMeMatrix?.products);

  const seen = new Set();
  const gallery = [];
  for (const entry of source) {
    if (gallery.length >= limit) break;
    const url = typeof entry?.url === "string" ? entry.url.trim() : "";
    if (!url || url === "null" || url === "undefined") continue;
    const key = dedupeKey(url);
    if (seen.has(key)) continue;
    seen.add(key);
    const productId = entry.productPublicId || entry.productId || null;
    gallery.push({
      url,
      productId,
      productName: entry.productName || "",
      productType: entry.productType || null,
      productUrl: buildFollowMeProductUrl(productId),
    });
  }
  return gallery;
}
